/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CampaignBuyersPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'
import {
  assignmentListParamsToRecord,
  assignmentListSearchFromRecord,
  type AssignmentListParams,
} from '@/lib/campaignBuyerList'
import { assignmentListRouteSearchSchema } from '@/features/shared/campaign-targets/lib/assignment-list-route-search'

export const Route = createFileRoute('/_authenticated/campaign-targets/')({
  validateSearch: z.object({
    campaign_id: z.string().optional(),
    customer_id: z.string().optional(),
    reseller_id: z.string().optional(),
    ...assignmentListRouteSearchSchema,
  }),
  component: CampaignBuyersRoute,
  beforeLoad: requireRole(['admin']),
})

function CampaignBuyersRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const listParams = assignmentListSearchFromRecord(search)

  const onListParamsChange = (next: AssignmentListParams) => {
    void navigate({
      search: {
        campaign_id: search.campaign_id,
        customer_id: search.customer_id,
        reseller_id: search.reseller_id,
        ...assignmentListParamsToRecord(next),
      },
      replace: true,
    })
  }

  return (
    <CampaignBuyersPage
      campaignId={search.campaign_id}
      customerId={search.customer_id}
      resellerId={search.reseller_id}
      listParams={listParams}
      onListParamsChange={onListParamsChange}
    />
  )
}
